var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"templates"},[_c('header-widget'),_c('h2',[_vm._v("Шаблоны")]),_c('topbar-templates'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }